import { render, staticRenderFns } from "./q-container.vue?vue&type=template&id=18f1af0d&scoped=true"
import script from "./q-container.vue?vue&type=script&lang=js"
export * from "./q-container.vue?vue&type=script&lang=js"
import style0 from "./q-container.vue?vue&type=style&index=0&id=18f1af0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1af0d",
  null
  
)

export default component.exports